import { useQuery } from "@tanstack/react-query";
import axios from "@api/axios";
import { useSession } from "@hooks/useSession";

const useAuthenticatedQuery = (queryKey, endpoint, options = {}) => {
  const { token } = useSession();
  const language = localStorage.getItem("ln") || "en"; // <-- Language fallback

  const queryFn = async () => {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Accept-Language": language, // <-- Inject Accept-Language
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
      throw error; // ✅ Ensure React Query catches the error
    }
  };

  return useQuery({
    queryKey,
    queryFn,
    ...options,
    enabled: Boolean(token && endpoint), // ✅ Fetch data only if the token exists
    retry: 2, // ✅ Retry twice before failing
    refetchOnWindowFocus: false, // ✅ Prevent refetching when user switches back to the tab
    onError: (error) => {
      console.error(`Failed to fetch ${endpoint}:`, error);
    },
  });
};

export default useAuthenticatedQuery;
